import workspaceQuery from '../../../graphql/queries/company/CurrencyWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/company/CurrencyListQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/CurrencyQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CurrencyDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CurrencyMutation.graphql';
import fragment from '../../../graphql/fragments/company/CurrencyFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const Currency: EntityType = {
  type: 'Currency',
  title: 'Currency Codes',
  formTitle: 'Currency Code',
  formUrl: '/Company/Currency/Details/',
  workspaceUrl: '/Company/Currency/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'CURRENCY_CODES',
};

export default Currency;
